import { render, staticRenderFns } from "./shaka_player.vue?vue&type=template&id=051606e3&"
import script from "./shaka_player.vue?vue&type=script&lang=js&"
export * from "./shaka_player.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports